const env = {
  backend_url: 'https://cutovertool.mybits.de/api'
};
export default env;
